// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"f6631093","405":"3a1c5cdc","792":"79c635e9","812":"204ce005"}[chunkId] + ".chunk.js";
};